import { Popper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PopperJs from 'popper.js';
import React, { useEffect, useRef, useState } from 'react';
import { EditableAllocationItem } from '../../../interface';
import ActionButtons from './ActionsButtons';
import { AllocItemActionsProps } from './types';

interface Props extends AllocItemActionsProps<EditableAllocationItem> {
  rootClassName?: string
  popperRef?: React.RefObject<PopperJs>
}

const useStyles = makeStyles({
  popper: {
    zIndex: 1300,
  },
});

export const ActionsCell: React.FC<Props> = ({ popperRef, ...props }) => {
  const classes = useStyles();
  const ref = useRef<HTMLDivElement>(null);
  const [areActionsShowed, setActionsShowed] = useState(false);

  useEffect(() => {
    setActionsShowed(true);
  }, []);

  return (
    <>
      <div ref={ref} className={props.rootClassName} />
      <Popper
        open={areActionsShowed}
        placement="bottom-end"
        anchorEl={ref.current}
        className={classes.popper}
      >
        <ActionButtons
          scrollBehavior="smooth"
          {...props} />
      </Popper>
    </>
  );
};
